// @ts-nocheck

export type OwnerGetWithPropertiesRooms = typeof OwnerGetWithPropertiesRooms[keyof typeof OwnerGetWithPropertiesRooms];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OwnerGetWithPropertiesRooms = {
  true: 'true',
  false: 'false',
} as const;
